import classnames from 'classnames';
import { forwardRef } from 'react';

import { useAccessibleInteractivity, useSyncedRef } from '../../../../../hooks';
import { connectLocation } from '../../../../location/LocationConnectors';
import Text from '../../../PageBuilder/utilities/Text';

const InteractiveLink = forwardRef(({ onClick, rootText, backToText, title, toFocusForAccessibility }, ref) => {
  const linkRef = useSyncedRef(ref);
  useAccessibleInteractivity(linkRef, event => {
    onClick(event);
    if (event.type === 'keydown') {
      toFocusForAccessibility && toFocusForAccessibility.current && toFocusForAccessibility.current.focus();
    }
  });

  return (
    <a data-track="filter" data-track-filter-name={title} data-track-filter-option={rootText} ref={linkRef}>
      <i className="icon icon-chevron-left" /> <span className="sr-only">{backToText}</span> <Text content={rootText} />
    </a>
  );
});

const LinkWithHref = forwardRef(({ href, rootText, backToText, title }, ref) => (
  <a href={href} data-track="filter" data-track-filter-name={title} data-track-filter-option={rootText} ref={ref}>
    <i className="icon icon-chevron-left" /> <span className="sr-only">{backToText}</span> <Text content={rootText} />
  </a>
));

const RootListItem = connectLocation(
  forwardRef(
    ({ hierarchyInPath, href, onClick, rootText, rootUrl, title, toFocusForAccessibility, selected, t }, ref) => {
      if (!selected) return null;

      return (
        <li className={classnames('parent', selected ? null : 'nohierarch')}>
          {href ? (
            <LinkWithHref href={href} rootText={rootText} backToText={t('product_list.back_to_all')} title={title} />
          ) : (
            <InteractiveLink
              onClick={onClick}
              ref={ref}
              rootText={rootText}
              backToText={t('product_list.back_to_all')}
              title={title}
              toFocusForAccessibility={toFocusForAccessibility}
            />
          )}
        </li>
      );
    }
  )
);

export default RootListItem;
